import { render, staticRenderFns } from "./tabbarSetting.vue?vue&type=template&id=76e47fcd&scoped=true"
import script from "./tabbarSetting.vue?vue&type=script&lang=js"
export * from "./tabbarSetting.vue?vue&type=script&lang=js"
import style0 from "./tabbarSetting.vue?vue&type=style&index=0&id=76e47fcd&prod&lang=scss&scoped=true"
import style1 from "./tabbarSetting.vue?vue&type=style&index=1&id=76e47fcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e47fcd",
  null
  
)

export default component.exports